import script from "./originalStockList.vue?vue&type=script&setup=true&lang=js"
export * from "./originalStockList.vue?vue&type=script&setup=true&lang=js"

import "./originalStockList.vue?vue&type=style&index=0&id=4eab779d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eab779d"]])

export default __exports__